import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { CatalogsAutocomplete } from "@shared/components/AutocompleteFields";

export const AgreementListFilters = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("v1/agreement_admin.filters.search")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <CatalogsAutocomplete
          name="plan"
          label={translate("v1/agreement_admin.filters.plan")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Checkbox
          name="subscribed"
          label={translate("v1/agreement_admin.filters.subscribed")}
        />
      </Grid>
    </Grid>
  );
});
